import React from "react";
import IntegratedDataLoading from "src/scenes/dashboard/integrated-data-loading";
import IntegratedInactive from "src/scenes/dashboard/integrated-inactive";
import IntegratedNoResponse from "src/scenes/dashboard/integrated-no-response";

const LoadingAndInactiveDataHandler = ({ name, fetchAction, isIntegrationInvalid }) => {
    if (!fetchAction) return <IntegratedNoResponse />;

    const dataLoading =
        fetchAction &&
        fetchAction.data &&
        fetchAction.data.meta &&
        !fetchAction.data.meta.firstScrappedDate &&
        !fetchAction.data.meta.lastActiveAt;

    const inactive =
        fetchAction && fetchAction.data && fetchAction.data.meta && fetchAction.data.meta.inactive;

    if (dataLoading) return <IntegratedDataLoading name={name} />;

    if (isIntegrationInvalid) {
        return <IntegratedInactive name={name} isInvalid />;
    }

    if (inactive)
        return (
            <IntegratedInactive
                name={name}
                lastActiveAt={fetchAction.data.meta.lastActiveAt}
                firstScrappedDate={fetchAction.data.meta.firstScrappedDate}
            />
        );

    return null;
};

export default LoadingAndInactiveDataHandler;
